import * as React from "react";
const SvgFiRrCloudCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-check_svg__a)">
      <path
        fill="#062147"
        d="M11.692 23a2.98 2.98 0 0 1-2.121-.88L6.184 18.7A1 1 0 1 1 7.6 17.3l3.384 3.414a1.025 1.025 0 0 0 1.41 0L17.81 15.3a1 1 0 1 1 1.415 1.414l-5.415 5.414a2.98 2.98 0 0 1-2.117.872M7 22a1 1 0 0 0-1-1h-.317a3.81 3.81 0 0 1-3.646-2.982 3.47 3.47 0 0 1 1.835-3.6 1.994 1.994 0 0 0 .792-2.686 6 6 0 1 1 11.06-4.513 3.1 3.1 0 0 0 2.044 2.053 5.97 5.97 0 0 1 4.213 6.21 5.85 5.85 0 0 1-4.293 5.077 1 1 0 0 0 .624 1.9 7.859 7.859 0 0 0 .044-15.1 1.09 1.09 0 0 1-.722-.735 8 8 0 0 0-15.49.842 7.65 7.65 0 0 0 .8 5.18A5.44 5.44 0 0 0 .057 18.3 5.84 5.84 0 0 0 5.683 23H6a1 1 0 0 0 1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudCheck;
